import React, { useEffect, useState, useRef, useContext } from 'react'
import { ButtonHeading, CommonInput, CommonModal, CommonToast, CustomPagination } from 'components'
import StorageService from "utils/StorageServices/StorageServices";
import toast, { Toaster } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { AddEditBranch } from 'modals';
import { deleteBranchData, getBranchListData, changeBranchStatusData } from '_services/accountsServices/branchServices';
import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import MastersFilterModal from 'modals/MastersFilterModal';
import LoadingBar from 'react-top-loading-bar';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import './branch.css'
import { CiLock } from 'react-icons/ci';
import { constant } from 'constants/constant';

const Branch = () => {

    const loadingBarRef = useRef(null);
    const prevFilterRef = useRef();

    const navigate = useNavigate();

    useDocumentTitle("Branch | T360");
    const { mastersChild, setMasterDetailsList } = useContext(UserContext);
    const masterChildBranch = mastersChild?.find((i) => i?.label === "Branch");

    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);

    const [branchList, setBranchList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        status: 1
    });

    const [checkboxStates, setCheckboxStates] = useState({});

    const toggleOffcanvas = () => {
        setShowOffcanvas(!showOffcanvas);
    };

    const getDatabranchList = async () => {
        try {
            setLoading(true);
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            }
            const res = await getBranchListData(object);
            if (res?.responseCode == 200) {
                setBranchList(res?.data?.branch_list)
                setTotalItems(res?.data?.total_record);
            } else {
                // toast.error(res?.responseMessage)
                CommonToast(res?.responseMessage)
            }
        } catch (error) {
            toast.error(error.message)
        } finally {
            setLoading(false);
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        const prevFilter = prevFilterRef.current;
        if (
            JSON.stringify(prevFilter) !== JSON.stringify(filter)
        ) {
            getDatabranchList();
            prevFilterRef.current = filter;
        }
    }, [filter, showOffcanvas, StorageService.getCompanyId()]);

    useEffect(() => {
        setMasterDetailsList({})
    }, [])

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteBranch = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                branch_id: isDelete?._id,
            }
            const res = await deleteBranchData(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                getDatabranchList();
                setLoading(false);
                setIsDelete(false);
            } else {
                toast.success('Error !! ');
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteBranch,
        isLoadding: loading,
    }

    const columns = [
        // { header: "", accessor: "serial" },
        { header: "Branch Name", accessor: "branch_name" },
        { header: "Firm", accessor: "firm_id" },
        { header: "Display Name", accessor: "display_name" },
        { header: "Branch Code", accessor: "branch_code" },
        { header: "City", accessor: "city" },
        { header: "Contact", accessor: "contact" },
        { header: "Email ID", accessor: "email_id" },
        { header: "Status", accessor: "status" },
        { header: "Action", accessor: "action" }

    ];

    useEffect(() => {
        if (branchList && branchList.length > 0) {
            const initialStates = branchList.reduce((acc, item) => {
                acc[item._id] = Boolean(item?.active);
                return acc;
            }, {});
            setCheckboxStates(initialStates);
        }
    }, [branchList]);

    const handleCheckboxChange = (id) => {
        const newStatus = !checkboxStates[id];
        setCheckboxStates(prevStates => ({ ...prevStates, [id]: newStatus }));

        const object = {
            company_id: StorageService.getCompanyId(),
            branch_id: id,
            active: Number(newStatus)
        };
        statusChangeofBranch(object);
    };

    const statusChangeofBranch = async (obj) => {
        try {
            if (obj) {
                const res = await changeBranchStatusData(obj);
                if (res?.responseCode === 200) {
                    toast.success(`${res?.responseMessage}`);
                } else {
                    toast.error('Error !!');
                    await getDatabranchList();
                }
            }
        } catch (error) {
            toast.error(error.message);
            await getDatabranchList();
        }
    };

    const editHandler = (data) => {
        setShowOffcanvas(data);
    };

    const handleClick = (event) => {
        event.stopPropagation();
    };

    const onRowClick = (e, item) => {
        navigate(`details/${item?._id}?type=${constant.m_type.branch}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`)
        setMasterDetailsList((s) => ({ ...s, list: branchList, details: item }))
    }

    const RowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
            serial:
                <React.Fragment>
                    <div className="signDropdown">
                        <button className="dropbtn11">
                            <BsThreeDotsVertical />
                        </button>
                        <div className="dropdownContent">
                            {masterChildBranch?.view === 1 && <Link to={`/account/branch/details/${item?._id}`}
                                className='_avPointer'
                                style={{ textDecoration: 'none' }}
                            >
                                <span className='_samAnchor'>
                                    <span className='viewIcon_avt'>
                                        <AiOutlineEye />
                                    </span>View
                                </span>
                            </Link>}

                            {masterChildBranch?.edit === 1 && <div
                                onClick={(e) => editHandler(item)}
                                className='_avPointer'
                            >
                                <span className='_samAnchor'>
                                    <span className='editIcon_avt'>
                                        <FiEdit />
                                    </span>
                                    Edit
                                </span>
                            </div>}

                            {masterChildBranch?.delete === 1 && <div
                                onClick={(e) => deleteHandler(item)}
                                className='_avPointer'
                            >
                                <span className='_samAnchor'>
                                    <span className='deleteIcon_avt'>
                                        <FaRegTrashCan color='red' />
                                    </span>
                                    Delete
                                </span>
                            </div>}
                        </div>
                    </div>
                </React.Fragment>,
            display_name:
                <React.Fragment>
                    {item?.display_name ? item?.display_name : '-'}
                </React.Fragment>,

            firm_id: <React.Fragment>
                {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
            </React.Fragment>,

            branch_code:
                <React.Fragment>
                    {item?.branch_code ? item?.branch_code : '-'}
                </React.Fragment>,
            branch_name:
                <Link
                    to={`details/${item?._id}?type=${constant.m_type.branch}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
                    style={{ textDecoration: 'none' }}
                    onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: branchList, details: item })) }}
                >
                    {item?.branch ? item?.branch : '-'}
                </Link>,
            city:
                <React.Fragment>
                    {item?.city?.label ? item?.city?.label : '-'}
                </React.Fragment>,
            contact:
                <React.Fragment>
                    {item?.contact_no ? item?.contact_no : '-'}
                </React.Fragment>,
            email_id:
                <React.Fragment>
                    {item?.email_id ? item?.email_id : '-'}
                </React.Fragment>,
            status: (
                <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }} onClick={(e) => handleClick(e)}>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        name="actStatus"
                        id={`actStatus-${item._id}`}
                        autoComplete="off"
                        checked={checkboxStates[item._id]}
                        onChange={() => handleCheckboxChange(item._id)}
                    />
                    <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
                        {checkboxStates[item._id] ? "Active" : "Disabled"}
                    </span>
                </div>
            ),
            action: (
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "100px" }}
                >
                    {masterChildBranch?.view === 1 &&
                        <Link
                            to={`details/${item?._id}?type=${constant.m_type.branch}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
                            className='_avPointer'
                            style={{ textDecoration: 'none' }}
                            onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: branchList, details: item })) }}
                        >
                            <span className='_samAnchor'>
                                <span className='viewIcon_avt'>
                                    <AiOutlineEye color='green' />
                                </span>
                            </span>
                        </Link>}

                    {masterChildBranch?.edit === 1 && <div
                        onClick={(e) => { handleClick(e); editHandler(item) }}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color='blue' />
                            </span>

                        </span>
                    </div>}

                    {(masterChildBranch?.delete === 1 && item?.is_default !== 1) && <div
                        onClick={(e) => { handleClick(e); deleteHandler(item) }}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='deleteIcon_avt'>
                                <FaRegTrashCan color='red' />
                            </span>

                        </span>
                    </div>}

                    {item?.is_default === 1 && <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            color: "#1450ec",
                        }}
                    >
                        <span>
                            <CiLock color="red" size={20} />
                        </span>
                    </div>}
                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };


    return (
        <div>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={"Branch"}
                onClick={toggleOffcanvas}
                buttonTitle={masterChildBranch?.create === 1 && "Add Branch"}
                showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                setFilter={setFilter}
                isDebouncedSearch={true}
            />

            {/* <div className='p-5'>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">S No.</th>
                            <th scope="col">Branch Name</th>
                            <th scope="col">Location</th>
                            <th scope="col">Created On</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            branchList?.length > 0 ? (
                                branchList?.map((el, ind) => {
                                    return (
                                        <tr key={ind + 'abc'}>
                                            <th scope="row">{ind + 1}</th>
                                            <td>
                                                <Link to={`/setting/branch/details/${el?._id}`}> {el?.branch} </Link>
                                            </td>
                                            <td>{el?.branch}</td>
                                            <td>{el?.city?.label ? el?.city?.label : '-'}</td>
                                            <td>
                                                <span disabled={loading}>Edit</span> &nbsp; &nbsp;
                                                <span onClick={(e) => deleteHandler(el)}>Delete</span>
                                            </td>
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr > <td> No data available </td> </tr>
                            )
                        }
                    </tbody>
                </table>
            </div> */}

            <div className='_tabWith_outTab'>
                <BootstrapTable
                    columns={columns}
                    data={RowListData(branchList?.length > 0 ? branchList : [])}
                    isLoading={loading}
                    onRowClick={(e, row) => {
                        if (e.target.closest(".no-row-click")) return; // ignore protected cells
                        onRowClick(e, row);
                    }}
                />

                {branchList?.length > 0 && <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div>}
            </div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showOffcanvas ? 'visible' : 'hidden' }}
            >
                {showOffcanvas &&
                    <AddEditBranch
                        isOpen={showOffcanvas}
                        onClose={(e) => { setShowOffcanvas(false); getDatabranchList(); }}
                    />
                }
            </div>
            <div className={showOffcanvas ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
            >
                {showFilterModal &&
                    <MastersFilterModal
                        isOpen={showFilterModal}
                        onClose={() => setShowFilterModal(false)}
                        filter={filter}
                        setFilter={setFilter}
                    />
                }
            </div>
            <div className={showFilterModal ? 'offBack_drop' : ''}></div>

            {
                isDelete?._id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete branch {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }
        </div>
    )
}

export default Branch